export default "__VITE_ASSET__wIRak$dQ$KBsiNSoOmNHfg__"